module.exports = __webpack_public_path__ + "static/media/Meistermannschaft_2009.df3e883c.png";